import React, { Component, useContext } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { ThemeContext } from '@emotion/core'
import { Carousel } from 'react-responsive-carousel'
import Contract from './Contract'

import useWindowWidth from '../../useWindowWidth'
import WindowWidthContext from '../../WindowWidthContext'

import 'react-responsive-carousel/lib/styles/carousel.min.css'
import { carouselSection } from '../Carousel'

const Section = styled.section`
  margin-top: 2rem;
  margin-bottom: 4rem;

  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  @media (max-width: ${props => props.theme.breakpoints.m}) {
    justify-content: space-evenly;
  }
`

const CarouselSection = styled.section`
  ${carouselSection};
`

export default function List(props) {
  const { contracts } = props
  const theme = useContext(ThemeContext)
  const showSlider = useContext(WindowWidthContext) <= parseInt(theme.breakpoints.s, 10)
  return !showSlider ? (
    <Section>
      {contracts.map(contract => (
        <Contract key={contract.node.id} node={contract.node} />
      ))}
    </Section>
  ) : (
    <CarouselSection>
      <Carousel swipeScrollTolerance={100} showThumbs={false} showStatus={false} showArrows={false}>
        {contracts.map(contract => (
          <Contract key={contract.node.id} node={contract.node} />
        ))}
      </Carousel>
    </CarouselSection>
  )
}

List.propTypes = {
  contracts: PropTypes.array.isRequired,
}
